<nav class="navigation-buttons" aria-label="Main navigation">
  <ng-container *ngFor="let button of buttons(); trackBy: trackByIcon">
    <a
      [routerLink]="button.route"
      routerLinkActive="nav-button--active"
      [routerLinkActiveOptions]="{ exact: button.exactRoute ?? false }"
      class="nav-button"
      [class.nav-button--hovered]="button.isActive"
      [attr.aria-label]="button.alt | translate"
      type="button"
    >
      <div class="nav-icon-wrapper">
        <img class="nav-icon-image" [src]="button.icon" [alt]="button.alt | translate" />
      </div>
    </a>
  </ng-container>
</nav>

